export const countryIdentity = {
  peru: {
    name: 'Perú',
    flag: '/flags/peru.svg',
    tagline: 'El talento deja huella',
    taglineStatus: 'current' as const,
    description: 'Talento que impulsa el futuro',
  },
  chile: {
    name: 'Chile',
    flag: '/flags/chile.svg',
    tagline: 'La magia del sur',
    taglineStatus: 'current' as const,
    description: 'Experiencia, especialización y talento distribuido',
  },
} as const
